import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';

export const FormsModalsRemoveControllerModule = angular
  .module('acme.view.application.forms.modals.remove.controllers', ['ui.bootstrap'])
  .controller('FormsModalsRemoveController', [
    '$scope',
    '$uibModalInstance',
    'item',
    'events',
    'allow',
    function FormsModalsRemoveController(
      $scope: IScope & { formsModalsRemove: TODO },
      $uibModalInstance: UIBModal<TODO>,
      item: TODO,
      events: TODO,
      allow: TODO
    ) {
      $scope.formsModalsRemove = {
        model: 'Your spankin new application.forms.modals.remove view!',

        name: item.name,
        events: events.data.payload || [],
        allow: allow,

        init: function () {},

        confirm: function () {
          $uibModalInstance.close(true);
        },

        close: function () {
          $uibModalInstance.dismiss('cancel');
        },

        success: {
          init: function (response) {},
        },

        error: {
          init: function (response) {},
        },
      };

      $scope.formsModalsRemove.init();
    },
  ]).name;
